import React from 'react';
import ScrapingShell from '../../../components/ScrapingShell';

/** Admin V2 Quit Monitor — Phase 2 shell. Feature : pages.quit_monitor.admin. */
const AdminV2QuitMonitor = () => (
  <ScrapingShell
    titleKey="quitV2.title" titleFallback="Quit monitor"
    bodyKey="quitV2.body"
    bodyFallback="Departure detection relies on the scraping pipeline (Backstage quit signals). Enabled per tenant once the data source is wired."
  />
);

export default AdminV2QuitMonitor;
